import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceNeutral20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFaceNeutral20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18M7.075 9.1a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m6.975-1.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0M6.204 12.5a.75.75 0 0 0 0 1.5h7.607a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceNeutral20Filled);
